define('layout-mobile',['isotope', 'helpers', 'utils'], function(Isotope) {
    'use strict';

    var layoutMobile,
        timeoutID;

    function LayoutMobile() {
        this.container = document.getElementById('content');
        this.content = document.getElementById('js-layout-content'),

        this.prop = {
            percentPosition: true,
            itemSelector: '[data-order]',
            getSortData: {
                category: '[data-order] parseInt'
            },
            layoutMode: 'vertical',
            sortBy : 'category',
            transitionDuration: 250
        };

        this.mobile = {};

        this.iso = null;

        if (window.attachEvent) {
            window.attachEvent('onresize', this.update.bind(this));
            this.container.attachEvent('onclick', this.update.bind(this));
        } else if(window.addEventListener) {
            window.addEventListener('resize', this.update.bind(this), true);
            this.container.addEventListener('touchend', this.update.bind(this), true);
            this.container.addEventListener('mouseup', this.update.bind(this), true);
        }
    }

    LayoutMobile.prototype.setImagePosition = function() {
        var image = document.getElementById('js-layout-image'),
            dataset = (image && image.dataset) ? image.dataset : null;

        if (!dataset) {
            return;
        }

        if (dataset.left) {
            image.style.left = dataset.left;
        } else if (dataset.right) {
            image.style.right = dataset.right;
        }
    };

    LayoutMobile.prototype.layout = function(i) {
        var _this = this;

        i = i || 0;

        if (!_this.iso || i > 5) {
            return;
        }

        _this.iso.layout();

        timeoutID = setTimeout(function() {
            _this.layout(++i);
        }, 150);
    };

    LayoutMobile.prototype.setOrder = function(mobile) {
        this.mobile = mobile || {};
    };

    LayoutMobile.prototype.init = function(columns) {
        columns = columns || window.getComputedStyle(document.getElementById('player'), ':after').getPropertyValue('content').replace(/"/g, '');

        if (this.iso || columns && columns === 'js-cols') {
            return;
        }

        this.content.classList.add('layout-content-isotope');

        var child,
            index,
            mobile,
            dataset,
            container = this.container.querySelector('.js-mobile-container'),
            children = container ? container.children : [],
            order = this.mobile.order && Array.isArray(this.mobile.order) ? this.mobile.order.map(function(str) {
                return str.toLowerCase();
            }) : [],
            fixed = this.mobile.fixed && Array.isArray(this.mobile.fixed) ? this.mobile.fixed.map(function(str) {
                return str.toLowerCase();
            }) : [],
            hidden = this.mobile.hidden && Array.isArray(this.mobile.hidden) ? this.mobile.hidden.map(function(str) {
                return str.toLowerCase();
            }) : [];

        for (var i = 0; i < children.length; i++) {
            child = children[i];
            index = -1;
            dataset = child.dataset;
            mobile = (dataset.mobile) ? dataset.mobile.toLowerCase() : '';

            child.classList.add('l-col-isotope');

            if (dataset.order) {
                index = dataset.order;
            } else {

                index = order.indexOf(mobile);

                if (fixed.indexOf(mobile) !== -1) {
                    child.classList.add('l-mobile-fixed');
                }

                if (hidden.indexOf(mobile) !== -1) {
                    child.classList.add('l-mobile-hidden');
                }
            }

            if (index === -1) {
                index = order.indexOf('componentdefault');
            }

            if (index === -1) {
                index = 99;
            }

            child.setAttribute('data-order', index);
        }

        this.iso = new Isotope(this.container, this.prop);

        if (timeoutID) {
            clearTimeout(timeoutID);
        }

        this.layout();
    };

    LayoutMobile.prototype.destroy = function() {
        if (!this.iso) {
            return;
        }

        var cols = this.container.querySelectorAll('.l-col-isotope');

        this.content.classList.remove('layout-content-isotope');

        for(var i = 0; i < cols.length; i++) {
            cols[i].classList.remove('l-col-isotope');
        }

        this.iso.destroy();
        this.setImagePosition();

        this.iso = null;
    };

    LayoutMobile.prototype.update = function() {
        var columns = window.getComputedStyle(document.getElementById('player'), ':after').getPropertyValue('content').replace(/"/g, '');

        if (timeoutID) {
            clearTimeout(timeoutID);
        }

        this.layout();

        if (columns && columns === 'js-cols') {
            this.destroy();
        } else {
            this.init(columns);
        }
    }

    return function(options) {

        if (!layoutMobile) {
            layoutMobile = new LayoutMobile(options);
        }

        return layoutMobile;
    };
});

